import AxiosURLSearchParams from '../../../helpers/AxiosURLSearchParams.js';

var URLSearchParams$1 = typeof URLSearchParams!=="undefined"?URLSearchParams:AxiosURLSearchParams;

export { URLSearchParams$1 as default };
//# sourceMappingURL=URLSearchParams.js.map
